// components/ProtectedRoute.js
import React from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';

const ProtectedRoute = ({ Component, ...rest }) => {
  const AuthenticatedComponent = withAuthenticator(Component);
  return <AuthenticatedComponent {...rest} />;
};

export default ProtectedRoute;